"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.writeDialog = exports.drawAll = exports.writeBg = exports.write = exports.setPos = exports.create = exports.RogueGlyphs = void 0;
var common_sidecar_1 = require("../../../main/common-sidecar");
var sprites_sidecar_1 = require("../../../sprites/sprites-sidecar");
var spritesUtil_sidecar_1 = require("../../../sprites/spritesUtil-sidecar");
var rogueMonofont_sidecar_1 = require("../monofont/rogueMonofont-sidecar");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var rogueLayers_sidecar_1 = require("../scene/rogueLayers-sidecar");
exports.RogueGlyphs = {
    // '*': rogueMonofont.getSprite('*'),
    // x: rogueMonofont.getSprite('x'),
    target: sprites_sidecar_1.sprites.rogue60,
    back: sprites_sidecar_1.sprites.monofont72,
    back2: sprites_sidecar_1.sprites.monofont73,
    horiz: sprites_sidecar_1.sprites.rogue46,
    '|': sprites_sidecar_1.sprites.rogue47,
    tl: sprites_sidecar_1.sprites.rogue45,
    tr: sprites_sidecar_1.sprites.rogue37,
    bl: sprites_sidecar_1.sprites.rogue35,
    br: sprites_sidecar_1.sprites.rogue36,
    // _default: sprites.rogue00,
};
var objs = [];
var _idx = 0;
// const objsVisible: IMonofontGlyph[] = []
var create = function () {
    // Find open glyph, if any
    while (_idx < objs.length) {
        var existing = objs[_idx];
        _idx++;
        if (existing.visible) {
            continue;
        }
        return existing;
    }
    var image = spritesUtil_sidecar_1.spritesUtil.createImage(rogueLayers_sidecar_1.rogueLayers.getLayers().ui1, sprites_sidecar_1.sprites.monofont64[0]);
    image.scale = rogueDef_sidecar_1.rogueDef.scale;
    var c = {
        x: 0,
        y: 0,
        char: '?',
        frames: sprites_sidecar_1.sprites.monofont64,
        image: image,
        visible: true,
        timeLeft: 0,
    };
    _idx++;
    objs.push(c);
    return c;
};
exports.create = create;
var setPos = function (c, x, y) {
    c.x = x;
    c.y = y;
};
exports.setPos = setPos;
var write = function (x, y, text, color, timeLeft, scale) {
    if (color === void 0) { color = 0xffffff; }
    if (timeLeft === void 0) { timeLeft = 0; }
    if (scale === void 0) { scale = 1; }
    var sprite = exports.RogueGlyphs[text] || null;
    if (!sprite) {
        sprite = rogueMonofont_sidecar_1.rogueMonofont.getSprite(text);
    }
    var c = (0, exports.create)();
    c.char = text;
    (0, exports.setPos)(c, x, y);
    spritesUtil_sidecar_1.spritesUtil.setPackedFrameSameScale(c.image, sprite[0]);
    c.image.tint = color;
    c.visible = true;
    c.timeLeft = timeLeft;
    c.image.scale = scale * rogueDef_sidecar_1.rogueDef.scale;
};
exports.write = write;
var writeBg = function (x, y, color, sprite, timeLeft) {
    if (color === void 0) { color = 0xffffff; }
    if (sprite === void 0) { sprite = exports.RogueGlyphs.back; }
    if (timeLeft === void 0) { timeLeft = 0; }
    // let sprite: ISPD[] = RogueGlyphs.back
    var c = (0, exports.create)();
    c.char = 'back';
    (0, exports.setPos)(c, x, y);
    spritesUtil_sidecar_1.spritesUtil.setPackedFrameSameScale(c.image, sprite[0]);
    c.image.tint = color;
    c.visible = true;
    c.timeLeft = timeLeft;
    c.image.scale = rogueDef_sidecar_1.rogueDef.scale;
};
exports.writeBg = writeBg;
var drawAll = function () {
    var elapsed = common_sidecar_1.common.getUpdateDelta();
    objs.forEach(function (c) {
        c.image.x = c.x * rogueDef_sidecar_1.rogueDef.sizeX;
        c.image.y = c.y * rogueDef_sidecar_1.rogueDef.sizeY;
        c.image.visible = c.visible;
        if (c.visible) {
            c.timeLeft -= elapsed;
            if (c.timeLeft <= 0) {
                c.visible = false; // reset
                c.timeLeft = 0;
            }
        }
    });
    _idx = 0;
};
exports.drawAll = drawAll;
var writeDialog = function (x, y, w, h, title, text, elapsed) {
    if (elapsed === void 0) { elapsed = 9999; }
    var color = rogueDef_sidecar_1.rogueDef.colors.light;
    var bgColor = rogueDef_sidecar_1.rogueDef.colors.darkBlue;
    var maxBack = elapsed / 0.002;
    for (var j = 0; j < h; j++) {
        for (var i = 0; i < w; i++) {
            if (i + j * w > maxBack) {
                continue;
            }
            (0, exports.writeBg)(x + i, y + j, bgColor);
        }
    }
    for (var i = 1; i < w - 1; i++) {
        if (i === 1 || i > title.length + 1) {
            if (i < maxBack) {
                (0, exports.writeBg)(x + i, y, color, exports.RogueGlyphs['horiz']);
            }
        }
        if (i + (h - 1) * w < maxBack) {
            (0, exports.writeBg)(x + i, y + h - 1, color, exports.RogueGlyphs['horiz']);
        }
    }
    for (var j = 1; j < h - 1; j++) {
        if (0 + j * h < maxBack) {
            (0, exports.writeBg)(x, y + j, color, exports.RogueGlyphs['|']);
        }
        if (w - 1 + j * h < maxBack) {
            (0, exports.writeBg)(x + w - 1, y + j, color, exports.RogueGlyphs['|']);
        }
    }
    (0, exports.writeBg)(x, y, color, exports.RogueGlyphs.tl);
    (0, exports.writeBg)(x + w - 1, y, color, exports.RogueGlyphs.tr);
    (0, exports.writeBg)(x, y + h - 1, color, exports.RogueGlyphs.bl);
    (0, exports.writeBg)(x + w - 1, y + h - 1, color, exports.RogueGlyphs.br);
    rogueMonofont_sidecar_1.rogueMonofont.write(x + 2, y, title, color);
    rogueMonofont_sidecar_1.rogueMonofont.writeWrapped(x + 1, y + 1, w - 2, text, color, bgColor, elapsed);
};
exports.writeDialog = writeDialog;
